import { parse, isValid, format } from 'date-fns';
import { globalBEDateFormat } from 'common/dateFormatConfig';

const tryParse = (dateStr, dateFormat) => {
  if (!dateStr) return null;
  const inUserFormat = parse(dateStr, dateFormat, new Date());
  if (isValid(inUserFormat)) return inUserFormat;
  const inBEFormat = parse(dateStr, globalBEDateFormat, new Date());
  return isValid(inBEFormat) ? inBEFormat : null;
};

const buildFromLegacy = (dateStr, time, dateFormat) => {
  if (!dateStr || !time) return null;
  const d = tryParse(dateStr, dateFormat);
  if (!d) return null;
  d.setHours(+time.hour || 0, +time.minute || 0, 0, 0);
  return d;
};

const padHourMinute = (value) => String(value).padStart(2, '0');

const deriveTimeObject = (date) =>
  date
    ? { hour: padHourMinute(date.getHours()), minute: padHourMinute(date.getMinutes()) }
    : null;

export const getTimeoffStartDate = (entity, dateFormat) => {
  if (!entity) return null;
  if (entity.utcStartDate) return new Date(entity.utcStartDate);
  if (entity.utcStartTime) return new Date(entity.utcStartTime);
  return buildFromLegacy(entity.startDate, entity.startTime, dateFormat);
};

export const getTimeoffEndDate = (entity, dateFormat) => {
  if (!entity) return null;
  if (entity.utcEndDate) return new Date(entity.utcEndDate);
  return buildFromLegacy(entity.endDate, entity.endTime, dateFormat);
};

export const getTimeoffStartTimeObject = (entity, dateFormat) => {
  if (entity?.utcStartDate || entity?.utcStartTime) {
    const fromUtc = deriveTimeObject(getTimeoffStartDate(entity, dateFormat));
    if (fromUtc) return fromUtc;
  }
  return entity?.startTime?.hour != null ? entity.startTime : null;
};

export const getTimeoffEndTimeObject = (entity, dateFormat) => {
  if (entity?.utcEndDate) {
    const fromUtc = deriveTimeObject(getTimeoffEndDate(entity, dateFormat));
    if (fromUtc) return fromUtc;
  }
  return entity?.endTime?.hour != null ? entity.endTime : null;
};

export const formatTimeoffTime = (date, is12Format) =>
  date ? format(date, is12Format ? 'h:mm a' : 'HH:mm') : null;

export const getTimeoffStartDateString = (entity, dateFormat) => {
  const date = getTimeoffStartDate(entity, dateFormat);
  return date ? format(date, dateFormat) : '';
};

export const getTimeoffEndDateString = (entity, dateFormat) => {
  const date = getTimeoffEndDate(entity, dateFormat);
  return date ? format(date, dateFormat) : '';
};
